module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-eddie-a1492b4a89de59376b34b4a0855e3abc.webp";